import { addToChainAfter, ApiHandlerDiscreteParameter, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { AddRmaApiParameter } from "@insite/client-framework/Services/OrderService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/RequestRma/Handlers/SendRmaRequest";
import { RmaModel } from "@insite/client-framework/Types/ApiModels";
import CustomApplicationState from "@wausauCustomBlueprint/Store/CustomApplicationState";
import { getWausauRequestRMAReturnPO } from "@wausauCustomBlueprint/Store/CustomSelector";

type SendRmaRequestParameter = {
    orderNumber: string;
    onError?: (errorMessage: string) => void;
} & HasOnSuccess<RmaModel>;

type HandlerType = ApiHandlerDiscreteParameter<SendRmaRequestParameter, AddRmaApiParameter, ServiceResult<RmaModel>>;

export const AddReturnPOToRequest: HandlerType = props => {
    const state = props.getState() as CustomApplicationState;
    const returnPO = getWausauRequestRMAReturnPO(state);

    if (returnPO && returnPO !== undefined && returnPO !== "" && returnPO !== null) {
        if (!props.apiParameter.rmaModel.properties) {
            props.apiParameter.rmaModel.properties = {};
        }
        props.apiParameter.rmaModel.properties["returnPO"] = returnPO;
    }
};

addToChainAfter(chain, PopulateApiParameter, AddReturnPOToRequest);
